// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"9e4ddd68","453":"89f79772","487":"6d143aae","525":"39632969","536":"bd54c556","883":"2542c1df"}[chunkId] + ".chunk.js";
};